import React from "react";
import { DialogContent, DialogContentText, DialogActions, Dialog, createStyles, Theme } from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import "./styles.css";
import { WithStyles, withStyles } from "@material-ui/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import WarningOutlinedIcon from "@material-ui/icons/WarningOutlined";
import { TypeDialog } from "../../models/enum/type-dialog";

interface Props {
	open: boolean;
	type: "atencao" | "erro" | "sucesso";
	text?: string;
	body?: any;
	buttons?: any;
	handleClose?: any;
}
const styles = (theme: Theme): any =>
	createStyles({
		root: {
			margin: 0,
			padding: theme.spacing(2),
		},
		closeButton: {
			position: "absolute",
			right: theme.spacing(1),
			top: theme.spacing(1),
			color: theme.palette.grey[500],
		},
	});

export interface DialogTitleProps extends WithStyles<typeof styles> {
	id: string;
	children: React.ReactNode;
	onClose?: () => void;
}
const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
});
const DialogBnb: React.FC<Props> = (props: Props) => {
	const { open = false, type, text, body, buttons, handleClose } = props;
	function getType(value): string {
		switch (value) {
			case TypeDialog.ATENCAO:
				return "Atenção";
			case TypeDialog.SUCESSO:
				return "Sucesso";
			case TypeDialog.ERRO:
				return "Erro";
			default:
				return "";
		}
	}
	return (
		<Dialog open={open} keepMounted>
			<DialogTitle id="alert-dialog-slide-title" onClose={handleClose}>
				{getType(type)}
			</DialogTitle>
			<DialogContent className="content">
				<DialogContentText id="alert-dialog-slide-description" className={type}>
					<WarningOutlinedIcon className="icone" />
					{text}
				</DialogContentText>
				<div>{body}</div>
			</DialogContent>
			<DialogActions>{buttons}</DialogActions>
		</Dialog>
	);
};
export default DialogBnb;